import { createContext, useState } from "react"

const NotificationContext = createContext()

const NotificationContextProvider = ({ children }) => {
  const [notification, setNotification] = useState({
    icon: null,
    title: null,
    type: "info",
    content: null,
    open: false,
    timeout: 10000,
    onCloseCallBack: () => {},
  })

  const notify = (details) => {
    setNotification({ ...notification, ...details })
  }

  const setOpen = open => setNotification(prevState => ({ ...prevState, open }))

  return (
    <NotificationContext.Provider value={{ notification, setNotification, open: notification.open, setOpen, notify, onCloseCallBack: notification.onCloseCallBack }}>
      {children}
    </NotificationContext.Provider>
  )
}

export { NotificationContext, NotificationContextProvider }
